import Distributor from '@/shared/models/entities/distributor'

export const auth = {
    namespaced: true,
    state: {
        distributor: null,
        distributor_user_name: null,
        access_token: null,
        access_token_expired: null,
        access_token_issued: null,
        refresh_token: null,
        refresh_token_expired: null,
        refresh_token_issued: null,
        is_signed_in: false,
    },
    mutations: {
        //APIのコールバックでよぶには actions が必要なはずだが
        //普通に呼べている件
        setAccessToken (state, param) {
            state.distributor = new Distributor(param.distributor);
            state.distributor_user_name = param.distributor_user_name;
            state.access_token = param.access_token;
            state.access_token_expired = param.access_token_expired;
            state.access_token_issued = param.access_token_issued;
            state.refresh_token = param.refresh_token;
            state.refresh_token_expired = param.refresh_token_expired;
            state.refresh_token_issued = param.refresh_token_issued;
            state.is_signed_in = true;
        },
        signOut (state) {
            state.distributor_name = null;
            state.distributor_user_name = null;
            state.access_token = null;
            state.access_token_expired = null;
            state.access_token_issued = null;
            state.refresh_token = null;
            state.refresh_token_expired = null;
            state.refresh_token_issued = null;
            state.is_signed_in = false;
        }
    }
}
